import React from "react";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] } }),
};

const IMG = "https://images.unsplash.com/photo-1739918069081-78dddf3240a6";

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-40 bg-[#0B0B0B]" data-testid="about-section">
      <div className="max-w-[1200px] mx-auto px-6 md:px-24">
        <div>
          <motion.h2 initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} custom={1} className="font-serif-display text-4xl md:text-6xl lg:text-7xl leading-[1.05] text-white/95 mb-10">
            An independent litigation practice<br/><span className="italic text-[#C8A45D]/90">rooted in discipline.</span>
          </motion.h2>
          <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} custom={2} className="hairline w-24 mb-10" />
          <div className="space-y-6 text-white/70 font-body text-base md:text-lg leading-relaxed max-w-2xl">
            {[
              "I am an independent litigation advocate practising before the Bombay High Court and its Kolhapur Bench. I represent clients across Maharashtra in matters that demand precision, restraint, and a considered legal strategy.",
              "My chamber is built on ethical advocacy, rigorous drafting, and a preference for quiet, thorough preparation over noise. Every matter receives my personal attention from the first consultation to the final order.",
              "I engage with criminal, civil, constitutional and service matters, and work closely with my clients to weigh options honestly before pursuing them in court.",
            ].map((p, i) => (
              <motion.p key={i} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} custom={i + 3}>{p}</motion.p>
            ))}
          </div>

          <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} custom={7} className="mt-12 max-w-2xl">
            <div className="border-l border-[#C8A45D]/40 pl-5">
              <div className="font-serif-display text-2xl md:text-3xl text-white leading-tight">Practice</div>
              <div className="text-[10px] font-cinzel tracking-[0.25em] text-white/50 mt-2">PRINCIPAL SEAT · BOMBAY &nbsp;·&nbsp; CIRCUIT BENCH · KOLHAPUR</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
